import {ClientLayout} from '../layouts'
import {GeneralSummary, Home, Leads, LegacySaleRegularization, NewExpense, NewSale, RecurringSales, UpdateSale} from '../pages/Client'

const routesClient = [
    {
        path: '/',
        layout: ClientLayout,
        component: Home,
    },
    {
        path: '/client/nueva-venta',
        layout: ClientLayout,
        component: NewSale,
    },
    {
        path: '/client/actualizar-venta',
        layout: ClientLayout,
        component: UpdateSale,
    },
    {
        path: '/client/regularizar-ventas',
        layout: ClientLayout,
        component: LegacySaleRegularization,
    },
    {
        path: '/client/nuevo-gasto',
        layout: ClientLayout,
        component: NewExpense,
    },
    {
        path: '/client/ventas-recurrentes',
        layout: ClientLayout,
        component: RecurringSales,
    },
    {
        path: '/client/resumen-general',
        layout: ClientLayout,
        component: GeneralSummary,
    },
    {
        path: '/client/leads',
        layout: ClientLayout,
        component: Leads,
    }
];

export default routesClient;
